module.exports = __webpack_public_path__ + "media/images/design/sizeM-wrap-1d3c6db976ccfeb605b9875c50513f91.png";